module.exports = __webpack_public_path__ + "static/media/gon_logo.9fe82a8e.svg";